import { useEffect } from "react";

import {
  allowScreenCaptureAsync,
  preventScreenCaptureAsync,
} from "expo-screen-capture";

import useAppStartupSplashScreenManager from "@/hooks/useAppStartupSplashScreenManager";
import useAuth from "@/hooks/useAuth";
import useFeatureFlags from "@/hooks/useFeatureFlags";
import { useSplashScreen } from "@/hooks/useSplashScreen";
import { isAndroid, isWeb } from "@/utils/platform.util";

const useAppStartupSplashScreen = ({
  isRootNavigatorReady,
}: {
  isRootNavigatorReady: boolean;
}) => {
  const { disableSplashScreen } = useSplashScreen();
  const { isAndroidSecurityScreenDisabled } = useFeatureFlags();
  const { isLoading: isLoadingCredentials } = useAuth();

  useEffect(() => {
    if (isWeb()) {
      // expo-screen-capture does not support react-native-web at all
      return;
    }
    if (isAndroid() && !isAndroidSecurityScreenDisabled) {
      // Enable the secure flag (no screenshots, no recents preview)
      // Disable the custom splash screen as it doesn't work on Android
      void preventScreenCaptureAsync();
      disableSplashScreen();
      return;
    }
    // iOS, or Android with isAndroidSecurityScreenDisabled
    void allowScreenCaptureAsync();
  }, [disableSplashScreen, isAndroidSecurityScreenDisabled]);

  useAppStartupSplashScreenManager({
    isLoadingCredentials,
    isRootNavigatorReady,
  });
};

export default useAppStartupSplashScreen;
